import { RoomBaseApiService } from "./room.baseapi.service";
import { ErrorWrapper, ResponseWrapper } from '@/core/service/util'

export class RoomNoticeService extends RoomBaseApiService {
    async getNotices() {
      try {
        const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/notices`)
        return new ResponseWrapper(response, response.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }

    async getNotice(params) {
      try {
        const response = await this.request().get(`/api/v3/room/${this.getRoomId()}/notice`,{
            ...params
        })
        return new ResponseWrapper(response, response.data)
      } catch (error) {
        throw new ErrorWrapper(error)
      }
    }
    
    async createNotice(params) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/notice/create`, {
                ...params
            })
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async deleteNotice(params) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/notice/delete`, {
                ...params
            })
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }

    async fixNotice(params) {
        try {
            const response = await this.request().post(`/api/v3/room/${this.getRoomId()}/notice/fix`, {
                ...params
            })
            return new ResponseWrapper(response, response.data)
        } catch (error) {
            throw new ErrorWrapper(error)
        }
    }
}

export const roomNoticeService = new RoomNoticeService()